import React, { Fragment } from "react";
import "containers/Projects/StartProject/Step_2/StartProjectStepTwo.css";
import ProjectOldInfo from "components/Project/Details/ProjectOldInfo";
import GiftGrid from "components/Project/StartProject/Step_2/GiftGrid";
import AxiosConfig from "axiosConfig";
import ProgressStepper from "components/Project/ProgressStepper";
import "containers/ProjectCommon.css";
import ProjectBanner from "components/Project/ProjectBanner";
import TwoButtonLayout from "components/General/Form/CustomButton/TwoButtonLayout";
import { withAlert } from "react-alert";

class StartProjectStepTwo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      projectBanner: "",
      photoSelectedId: "",
      imageList: [
        {
          prize_id: "",
          prize_url: "",
        },
      ],
    };
  }

  componentDidMount() {
    this.fetchPrizeDetails(this);
    this.fetchProjectBanner();
    window.onpopstate = (e) => {
      this.onBackButtonEvent();
    };
  }
  onBackButtonEvent = () => {
    this.props.history.push({
      pathname: `/projects/`
    });
  };
  fetchProjectBanner() {
    const projectSlug = this.props.location.state.projectSlug;
    AxiosConfig.get(`impactprojects/project/${projectSlug}/`)
      .then((res) => {
        this.setState({
          projectBanner: res.data["banner"],
        });
      })
      .catch();
  }

  setPrizeDetails(response) {
    this.setState((prevState) => ({
      imageList: response.data["image_list"],
    }));
  }

  fetchPrizeDetails(obj) {
    AxiosConfig.get(`prize/prizeList`)
      .then(function (response) {
        obj.setPrizeDetails(response);
      })
      .catch(function (error) {});
  }

  giftPlanSelectedHandler(value) {
    this.setState((prevState) => ({
      photoSelectedId: value,
    }));
  }

  moveToStepThreeHandler(event) {
    // if the prize is selected
    let form_data = new FormData();
    const {
      projectUserId,
      projectSlug,
      goalDate,
      challengeSlug,
    } = this.props.location.state;
    if (this.state.photoSelectedId) {
      form_data.append("project", projectSlug);
      form_data.append("prize", this.state.photoSelectedId);
      form_data.append("challenge", challengeSlug);
      form_data.append("projectUserId", projectUserId);
      AxiosConfig.put(`/impactprojects/start_project_new/`, form_data, {
        headers: {
          "content-type": "multipart/form-data",
        },
      })
        .then(() => {
          if (event == "save") window.location.assign("/projects");
          else
            this.props.history.push({
              pathname: `/projects/${projectSlug}/start-project-step-three`,
              state: {
                challengeSlug: challengeSlug,
                projectSlug: projectSlug,
                goalDate: goalDate,
                adventureId: this.props.location.state.adventureId,
                adventureSlug: this.props.location.state.adventureSlug,
                projectUserId: projectUserId,
              },
            });
        })
        .catch();
    } else {
      const alert = this.props.alert;
      alert.show("Please select one prize to proceed!", {
        position: "top right",
      });
    }
  }

  render() {
    return (
      <Fragment>
        <div className="header_main">
          <div className="page_main">
            <div className="page_info_vr_content_main">
              <ProjectOldInfo
                vertical={true}
                project={this.props.location.state.projectSlug}
              />
            </div>
            <div className="page_details_main">
              <div className="project-banner">
                <ProjectBanner image={this.state.projectBanner} />
              </div>
              <div className="page_info_hr_content_main">
                <ProjectOldInfo
                  project={this.props.location.state.projectSlug}
                  showChallengeDetails={true}
                />
              </div>
              <div className="page_details_content_main mt-15 border-0">
                <div className="stepper_main_content">
                  <ProgressStepper
                    currentStep="2"
                    challengeSlug={this.props.location.state.challengeSlug}
                    goalDate={this.props.location.state.goalDate}
                    adventureId={this.props.location.state.adventureId}
                    projectSlug={this.props.location.state.projectSlug}
                    adventureSlug={this.props.location.state.adventureSlug}
                    projectUserId={this.props.location.state.projectUserId}
                    showStepper={true}
                  />
                </div>
              </div>
              <div className="page_details_content_main">
                <div className="project-details">
                  <div className="insideContent">
                    <h3 className="textHeader">STEP 3 : PLAN YOUR THANK YOU</h3>
                    <p className="insideContent">
                      Reward your Project Team with a secret gift when they
                      complete the Project.
                    </p>
                  </div>
                  <div className="prize-list">
                    {this.state.imageList[0].prize_url ? (
                      <GiftGrid
                        prizeData={this.state.imageList}
                        onClick={this.giftPlanSelectedHandler.bind(this)}
                      />
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="mt-15">
                <TwoButtonLayout
                  button1Text="SAVE"
                  button2Text="NEXT"
                  button1Click={this.moveToStepThreeHandler.bind(this, "save")}
                  button2Click={this.moveToStepThreeHandler.bind(this, "move")}
                />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withAlert()(StartProjectStepTwo);
